// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section_outer {
    display: flex;
    position: relative;
    height: 100vh;
    align-items: center;
    overflow: hidden;
    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);
    scrollbar-width: none;
    -ms-overflow-style: none;
    scroll-snap-align: start;
}

.section_outer::-webkit-scrollbar{display: none;}

  .home-section {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
    flex-wrap: wrap-reverse;
}

.home-content {
    display: flex;
    flex-direction: column;
    width: 60%;
    height: -moz-fit-content;
    height: fit-content;
    margin-top: 7rem;
    color: var(--text-color);
}

.home-content h3{
    color: var(--text-color);
    font-size: 2.3rem;
    font-weight: 500;
}

.home-content h3:nth-of-type(2){
    margin-bottom: 1rem;
}

span{
    color: var(--main-color);
}

.home-content h1{
    font-size: 3.4rem;
    font-weight: 650;
    line-height: 1.2;  
}

.home-content{
    .card{
        text-align: justify;
        position: relative;
        box-shadow: 4px 4px 12px -5px var(--text-color);
        border-radius: 15px;
        background: rgb(255, 255, 255, 0.1);
        display: flex;
        flex-wrap: wrap;
        border-top: 1px solid var(--text-color);
        border-left: 1px solid var(--text-color);
        -webkit-backdrop-filter: blur(3px);
                backdrop-filter: blur(3px);
    }
}
.home-content p{
    padding: 1rem;
    margin-top: -4px;
    font-size: 1rem;
}

.home-img{
    display: flex;
    justify-content: center;
    align-items: center;
    width: -moz-fit-content;
    width: fit-content;
}

.home-img img{
    display: flex;
    width: 255px;
    height: 255px;
    border-radius: 50%;
    border: .2rem solid var(--text-color);
    filter:drop-shadow(0px 0px 3px var(--text-color)) drop-shadow(0 0 10px var(--bg-color));
    animation: zoomIn1 1s ease forwards,floatImage 4s ease-in-out infinite;
    animation-delay: 1s,2s;
    transition: 0.5s ease-in-out;
}

.home-img .circle-spin {
    position: absolute;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    border-top: .2rem solid var(--bg-color);
    border-bottom: .2rem solid var(--bg-color);
    border-left: .2rem solid var(--main-color);
    border-right: .2rem solid var(--main-color);
    animation: homeSpinner 15s linear infinite;
}

@keyframes homeSpinner {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform:  rotate(360deg);
    }
}

.home-content .social-media a{
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 3.6rem;
    height: 3.6rem;
    background: transparent;
    border: .2rem solid var(--main-color);
    border-radius: 50%;
    font-size: 1.8rem;
    color: var(--text-color);
    margin: 1.5rem 2rem 2rem 0;
    transition: .5s ease;
}

.home-content .social-media a:hover{
    background: var(--main-color);
    color:var(--text-color);
    box-shadow: 0 0 1rem var(--main-color)
}

.btns{
    display: flex;
    width: -moz-fit-content;
    width: fit-content;
    flex-wrap: wrap;
}

.home-content{
    .btn {
        display:block;
        margin: 0rem 2rem 3rem 0;
        background: var(--main-color);
        color: var(--text-color);    
        padding: 0.8rem 1.5rem;
        border-radius: 4rem;
        box-shadow: 0 0 0.5rem var(--text-color);
        width: -moz-fit-content;
        width: fit-content;
        font-size: 1.4rem;
        letter-spacing: 0.1rem;
        font-weight: 600;
        transition: .5s ease;
        cursor: pointer;
}
}

.home-content{
    .btn:hover{
    box-shadow: 0 0 0.9rem var(--text-color);
    background-color: var(--text-color);
    color: var(--main-color);
    transition: 0.4s ease;
}
}

@media(max-width:998px){
    
    .section_outer{
        top:0%;
        height: -moz-fit-content;
        height: fit-content;
        flex-wrap: wrap;
    }

    .home-section{
        margin-top: 24%;
    }

    .home-content {
        margin-top: 2rem;
        width:97%;
        align-content: center;
    }
    .home-content h3{
        font-size: 1.7rem;
    }
    .home-content h3:nth-of-type(2){
        font-size: 1.54rem;
    }
    .home-img img{
        width: 200px;
        height: 200px;
    }
    .home-img .circle-spin {
        width: 220px;
        height: 220px;
    }
    .home-content h1{
    font-size: 2.2rem;
    }

    .home-content p{
        text-align: justify;
        padding: 1.1rem 0.7rem 0.6rem 0.6rem;
        font-size: 0.89rem;
        letter-spacing: 0.01rem;
    }

    .home-content .social-media{
        align-self: center;
        justify-self: center;
        align-items: center;
        justify-content: center;
    }

    .home-content .social-media a{
        margin-top: 25px;
        margin: 1.5rem 0.7rem 1.5rem 0.7rem;
    }

    .btns{
        align-items: center;
        justify-content: center;
    }

    .home-content{
        .btn {
        	margin: 1.5rem 0rem 1.5rem 0rem;
            padding: 0.9rem 2rem;
            font-size: 1.2rem;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,6CAA6C;IAC7C,qBAAqB;IACrB,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA,kCAAkC,aAAa,CAAC;;EAE9C;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,wBAAmB;IAAnB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;QACnB,kBAAkB;QAClB,+CAA+C;QAC/C,mBAAmB;QACnB,mCAAmC;QACnC,aAAa;QACb,eAAe;QACf,uCAAuC;QACvC,wCAAwC;QACxC,kCAA0B;gBAA1B,0BAA0B;IAC9B;AACJ;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,uFAAuF;IACvF,sEAAsE;IACtE,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,0CAA0C;IAC1C,0CAA0C;IAC1C,2CAA2C;IAC3C,0CAA0C;AAC9C;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,aAAa;QACb,wBAAwB;QACxB,6BAA6B;QAC7B,wBAAwB;QACxB,sBAAsB;QACtB,mBAAmB;QACnB,wCAAwC;QACxC,uBAAkB;QAAlB,kBAAkB;QAClB,iBAAiB;QACjB,sBAAsB;QACtB,gBAAgB;QAChB,oBAAoB;QACpB,eAAe;AACvB;AACA;;AAEA;IACI;IACA,wCAAwC;IACxC,mCAAmC;IACnC,wBAAwB;IACxB,qBAAqB;AACzB;AACA;;AAEA;;IAEI;QACI,MAAM;QACN,wBAAmB;QAAnB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,SAAS;QACT,qBAAqB;IACzB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;IACA;IACA,iBAAiB;IACjB;;IAEA;QACI,mBAAmB;QACnB,oCAAoC;QACpC,kBAAkB;QAClB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,mCAAmC;IACvC;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI;SACC,+BAA+B;YAC5B,oBAAoB;YACpB,iBAAiB;QACrB;IACJ;AACJ","sourcesContent":[".section_outer {\n    display: flex;\n    position: relative;\n    height: 100vh;\n    align-items: center;\n    overflow: hidden;\n    box-shadow: 20px 20px 50px rgba(0, 0, 0, 0.5);\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    scroll-snap-align: start;\n}\n\n.section_outer::-webkit-scrollbar{display: none;}\n\n  .home-section {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100%;\n    height: fit-content;\n    flex-wrap: wrap-reverse;\n}\n\n.home-content {\n    display: flex;\n    flex-direction: column;\n    width: 60%;\n    height: fit-content;\n    margin-top: 7rem;\n    color: var(--text-color);\n}\n\n.home-content h3{\n    color: var(--text-color);\n    font-size: 2.3rem;\n    font-weight: 500;\n}\n\n.home-content h3:nth-of-type(2){\n    margin-bottom: 1rem;\n}\n\nspan{\n    color: var(--main-color);\n}\n\n.home-content h1{\n    font-size: 3.4rem;\n    font-weight: 650;\n    line-height: 1.2;  \n}\n\n.home-content{\n    .card{\n        text-align: justify;\n        position: relative;\n        box-shadow: 4px 4px 12px -5px var(--text-color);\n        border-radius: 15px;\n        background: rgb(255, 255, 255, 0.1);\n        display: flex;\n        flex-wrap: wrap;\n        border-top: 1px solid var(--text-color);\n        border-left: 1px solid var(--text-color);\n        backdrop-filter: blur(3px);\n    }\n}\n.home-content p{\n    padding: 1rem;\n    margin-top: -4px;\n    font-size: 1rem;\n}\n\n.home-img{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: fit-content;\n}\n\n.home-img img{\n    display: flex;\n    width: 255px;\n    height: 255px;\n    border-radius: 50%;\n    border: .2rem solid var(--text-color);\n    filter:drop-shadow(0px 0px 3px var(--text-color)) drop-shadow(0 0 10px var(--bg-color));\n    animation: zoomIn1 1s ease forwards,floatImage 4s ease-in-out infinite;\n    animation-delay: 1s,2s;\n    transition: 0.5s ease-in-out;\n}\n\n.home-img .circle-spin {\n    position: absolute;\n    width: 280px;\n    height: 280px;\n    border-radius: 50%;\n    border-top: .2rem solid var(--bg-color);\n    border-bottom: .2rem solid var(--bg-color);\n    border-left: .2rem solid var(--main-color);\n    border-right: .2rem solid var(--main-color);\n    animation: homeSpinner 15s linear infinite;\n}\n\n@keyframes homeSpinner {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform:  rotate(360deg);\n    }\n}\n\n.home-content .social-media a{\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 3.6rem;\n    height: 3.6rem;\n    background: transparent;\n    border: .2rem solid var(--main-color);\n    border-radius: 50%;\n    font-size: 1.8rem;\n    color: var(--text-color);\n    margin: 1.5rem 2rem 2rem 0;\n    transition: .5s ease;\n}\n\n.home-content .social-media a:hover{\n    background: var(--main-color);\n    color:var(--text-color);\n    box-shadow: 0 0 1rem var(--main-color)\n}\n\n.btns{\n    display: flex;\n    width: fit-content;\n    flex-wrap: wrap;\n}\n\n.home-content{\n    .btn {\n        display:block;\n        margin: 0rem 2rem 3rem 0;\n        background: var(--main-color);\n        color: var(--text-color);    \n        padding: 0.8rem 1.5rem;\n        border-radius: 4rem;\n        box-shadow: 0 0 0.5rem var(--text-color);\n        width: fit-content;\n        font-size: 1.4rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        transition: .5s ease;\n        cursor: pointer;\n}\n}\n\n.home-content{\n    .btn:hover{\n    box-shadow: 0 0 0.9rem var(--text-color);\n    background-color: var(--text-color);\n    color: var(--main-color);\n    transition: 0.4s ease;\n}\n}\n\n@media(max-width:998px){\n    \n    .section_outer{\n        top:0%;\n        height: fit-content;\n        flex-wrap: wrap;\n    }\n\n    .home-section{\n        margin-top: 24%;\n    }\n\n    .home-content {\n        margin-top: 2rem;\n        width:97%;\n        align-content: center;\n    }\n    .home-content h3{\n        font-size: 1.7rem;\n    }\n    .home-content h3:nth-of-type(2){\n        font-size: 1.54rem;\n    }\n    .home-img img{\n        width: 200px;\n        height: 200px;\n    }\n    .home-img .circle-spin {\n        width: 220px;\n        height: 220px;\n    }\n    .home-content h1{\n    font-size: 2.2rem;\n    }\n\n    .home-content p{\n        text-align: justify;\n        padding: 1.1rem 0.7rem 0.6rem 0.6rem;\n        font-size: 0.89rem;\n        letter-spacing: 0.01rem;\n    }\n\n    .home-content .social-media{\n        align-self: center;\n        justify-self: center;\n        align-items: center;\n        justify-content: center;\n    }\n\n    .home-content .social-media a{\n        margin-top: 25px;\n        margin: 1.5rem 0.7rem 1.5rem 0.7rem;\n    }\n\n    .btns{\n        align-items: center;\n        justify-content: center;\n    }\n\n    .home-content{\n        .btn {\n        \tmargin: 1.5rem 0rem 1.5rem 0rem;\n            padding: 0.9rem 2rem;\n            font-size: 1.2rem;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
